import React from "react";
import NotificationItem from "./NotificationItem";

const Notifications = ({
    data = [],
    onReadNotification = () => {},
    errorMessage = null,
    emptyMessage = null,
}) => {
    if (errorMessage) {
        return <div className="NotificationsError">{errorMessage}</div>;
    }
    if (!Array.isArray(data) || data.length === 0) {
        return <div className="NotificationsError">{emptyMessage}</div>;
    }

    return (
        <div className="Notifications">
            {data.map(({ id, date, subject, text }) => (
                <NotificationItem
                    onClick={onReadNotification}
                    key={id}
                    id={id}
                    date={date}
                    subject={subject}
                    text={text}
                />
            ))}
        </div>
    );
};


export default Notifications;
